import OverallQAReport from "./OverallQAReport.component";

export default OverallQAReport;
